// Digest: 4f1d1677ee84cfd0e0ae62d2c37f828c8224a03b
/* eslint-disable */
/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface _Types {
  HelloWorldProps: ServerCoreTemplateHelloWorld;
  HomeProps: ServerCoreTemplateHome;
  ProductProps: ServerCoreTemplateProduct;
  AboutUsProps: ServerCoreTemplateAboutUs;
  GrindingBallsProps: ServerCoreTemplateGrindingBalls;
  MillLinersProps: ServerCoreTemplateMillLiners;
  BodyLinerProps: ServerCoreTemplateBodyLiner;
  BallLoadingProps: ServerCoreTemplateBallLoading;
  BallSortingProps: ServerCoreTemplateBallSorting;
  MiningEquipemntProps: ServerCoreTemplateMiningEquipemnt;
  CrushersProps: ServerCoreTemplateCrushers;
  MobileSeriesProps: ServerCoreTemplateMobileSeries;
  SemiMobileSeriesProps: ServerCoreTemplateSemiMobileSeries;
  SparesProps: ServerCoreTemplateSpares;
  CementMillLinersProps: ServerCoreTemplateCementMillLiners;
  DipTubeProps: ServerCoreTemplateDipTube;
  globals: {
    Widget: generated.Types["Widget"];
    models: null;
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor;
  RPCPermission: null;
}
export interface ServerCoreTemplateHelloWorld {
  name: string;
}
export interface ServerCoreTemplateHome {}
export interface ServerCoreTemplateProduct {}
export interface ServerCoreTemplateAboutUs {}
export interface ServerCoreTemplateGrindingBalls {}
export interface ServerCoreTemplateMillLiners {}
export interface ServerCoreTemplateBodyLiner {}
export interface ServerCoreTemplateBallLoading {}
export interface ServerCoreTemplateBallSorting {}
export interface ServerCoreTemplateMiningEquipemnt {}
export interface ServerCoreTemplateCrushers {}
export interface ServerCoreTemplateMobileSeries {}
export interface ServerCoreTemplateSemiMobileSeries {}
export interface ServerCoreTemplateSpares {}
export interface ServerCoreTemplateCementMillLiners {}
export interface ServerCoreTemplateDipTube {}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}

const urls = {"core:hello-world":{"route":"/hello_world/","args":{}},"core:home":{"route":"/","args":{}},"core:product":{"route":"/product/","args":{}},"about/":{"route":"/about/","args":{}},"core:grinding-media":{"route":"/product/grinding-media/","args":{}},"core:mill-liners":{"route":"/product/cement-mill-liners/","args":{}},"core:body-liner":{"route":"/product/body-liners/","args":{}},"core:ball_loading":{"route":"/product/ball-loading/","args":{}},"core:ball_sorting":{"route":"/product/ball-sorting/","args":{}},"core:mining_equipment":{"route":"/product/mining-equipment/","args":{}},"core:crushers":{"route":"/product/crushers/","args":{}},"product/mobile-series/":{"route":"/product/mobile-series/","args":{}},"product/semi-mobile-series/":{"route":"/product/semi-mobile-series/","args":{}},"core:spares":{"route":"/product/spares/","args":{}},"core:cement_mill_liners":{"route":"/product/mill-liners/","args":{}},"core:dip_tube":{"route":"/product/dip-tube/","args":{}},"send_email_api":{"route":"/api/send-email/","args":{}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

interface URLMap {
    core_hello_world: core_hello_world;
    core_home: core_home;
    core_product: core_product;
    about_: about_;
    core_grinding_media: core_grinding_media;
    core_mill_liners: core_mill_liners;
    core_body_liner: core_body_liner;
    core_ball_loading: core_ball_loading;
    core_ball_sorting: core_ball_sorting;
    core_mining_equipment: core_mining_equipment;
    core_crushers: core_crushers;
    product_mobile_series_: product_mobile_series_;
    product_semi_mobile_series_: product_semi_mobile_series_;
    core_spares: core_spares;
    core_cement_mill_liners: core_cement_mill_liners;
    core_dip_tube: core_dip_tube;
    send_email_api: send_email_api;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface core_hello_world {
    name: 'core:hello-world';
    args: core_hello_world_args;
}

interface core_hello_world_args {
}

interface core_home {
    name: 'core:home';
    args: core_home_args;
}

interface core_home_args {
}

interface core_product {
    name: 'core:product';
    args: core_product_args;
}

interface core_product_args {
}

interface about_ {
    name: 'about/';
    args: about__args;
}

interface about__args {
}

interface core_grinding_media {
    name: 'core:grinding-media';
    args: core_grinding_media_args;
}

interface core_grinding_media_args {
}

interface core_mill_liners {
    name: 'core:mill-liners';
    args: core_mill_liners_args;
}

interface core_mill_liners_args {
}

interface core_body_liner {
    name: 'core:body-liner';
    args: core_body_liner_args;
}

interface core_body_liner_args {
}

interface core_ball_loading {
    name: 'core:ball_loading';
    args: core_ball_loading_args;
}

interface core_ball_loading_args {
}

interface core_ball_sorting {
    name: 'core:ball_sorting';
    args: core_ball_sorting_args;
}

interface core_ball_sorting_args {
}

interface core_mining_equipment {
    name: 'core:mining_equipment';
    args: core_mining_equipment_args;
}

interface core_mining_equipment_args {
}

interface core_crushers {
    name: 'core:crushers';
    args: core_crushers_args;
}

interface core_crushers_args {
}

interface product_mobile_series_ {
    name: 'product/mobile-series/';
    args: product_mobile_series__args;
}

interface product_mobile_series__args {
}

interface product_semi_mobile_series_ {
    name: 'product/semi-mobile-series/';
    args: product_semi_mobile_series__args;
}

interface product_semi_mobile_series__args {
}

interface core_spares {
    name: 'core:spares';
    args: core_spares_args;
}

interface core_spares_args {
}

interface core_cement_mill_liners {
    name: 'core:cement_mill_liners';
    args: core_cement_mill_liners_args;
}

interface core_cement_mill_liners_args {
}

interface core_dip_tube {
    name: 'core:dip_tube';
    args: core_dip_tube_args;
}

interface core_dip_tube_args {
}

interface send_email_api {
    name: 'send_email_api';
    args: send_email_api_args;
}

interface send_email_api_args {
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |__reactivated_do_not_use_args;
type WithoutArguments = |core_hello_world|core_home|core_product|about_|core_grinding_media|core_mill_liners|core_body_liner|core_ball_loading|core_ball_sorting|core_mining_equipment|core_crushers|product_mobile_series_|product_semi_mobile_series_|core_spares|core_cement_mill_liners|core_dip_tube|send_email_api|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

export type {Options} from "reactivated/dist/conf";

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import createContext from "reactivated/dist/context";
import * as forms from "reactivated/dist/forms";
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export const {Context, Provider, getServerData} = createContext<_Types["Context"]>();

export const getTemplate = ({template_name}: {template_name: string}) => {
    // This require needs to be *inside* the function to avoid circular dependencies with esbuild.
    const { default: templates, filenames } = require('../../client/templates/**/*');
    const templatePath = "../../client/templates/" + template_name + ".tsx";
    const possibleTemplate: {default: React.ComponentType<any>} | null = templates.find((t: any, index: number) => filenames[index] === templatePath);

    if (possibleTemplate == null) {
        throw new Error("Template " + template_name + ".tsx not found");
    }
    return possibleTemplate.default;
}

export const CSRFToken = forms.createCSRFToken(Context);

export const {createRenderer, Iterator} = forms.bindWidgetType<_Types["globals"]["Widget"]>();
export type FieldHandler = forms.FieldHandler<_Types["globals"]["Widget"]>;
export type models = _Types["globals"]["models"];

export type {FormHandler} from "reactivated/dist/forms";
export const {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} = forms;


import HelloWorldImplementation from "@client/templates/HelloWorld"
export type HelloWorldCheck = Checker<_Types["HelloWorldProps"], typeof HelloWorldImplementation>;

export namespace templates {
    export type HelloWorld = _Types["HelloWorldProps"];
}


        



import HomeImplementation from "@client/templates/Home"
export type HomeCheck = Checker<_Types["HomeProps"], typeof HomeImplementation>;

export namespace templates {
    export type Home = _Types["HomeProps"];
}


        



import ProductImplementation from "@client/templates/Product"
export type ProductCheck = Checker<_Types["ProductProps"], typeof ProductImplementation>;

export namespace templates {
    export type Product = _Types["ProductProps"];
}


        



import AboutUsImplementation from "@client/templates/AboutUs"
export type AboutUsCheck = Checker<_Types["AboutUsProps"], typeof AboutUsImplementation>;

export namespace templates {
    export type AboutUs = _Types["AboutUsProps"];
}


        



import GrindingBallsImplementation from "@client/templates/GrindingBalls"
export type GrindingBallsCheck = Checker<_Types["GrindingBallsProps"], typeof GrindingBallsImplementation>;

export namespace templates {
    export type GrindingBalls = _Types["GrindingBallsProps"];
}


        



import MillLinersImplementation from "@client/templates/MillLiners"
export type MillLinersCheck = Checker<_Types["MillLinersProps"], typeof MillLinersImplementation>;

export namespace templates {
    export type MillLiners = _Types["MillLinersProps"];
}


        



import BodyLinerImplementation from "@client/templates/BodyLiner"
export type BodyLinerCheck = Checker<_Types["BodyLinerProps"], typeof BodyLinerImplementation>;

export namespace templates {
    export type BodyLiner = _Types["BodyLinerProps"];
}


        



import BallLoadingImplementation from "@client/templates/BallLoading"
export type BallLoadingCheck = Checker<_Types["BallLoadingProps"], typeof BallLoadingImplementation>;

export namespace templates {
    export type BallLoading = _Types["BallLoadingProps"];
}


        



import BallSortingImplementation from "@client/templates/BallSorting"
export type BallSortingCheck = Checker<_Types["BallSortingProps"], typeof BallSortingImplementation>;

export namespace templates {
    export type BallSorting = _Types["BallSortingProps"];
}


        



import MiningEquipemntImplementation from "@client/templates/MiningEquipemnt"
export type MiningEquipemntCheck = Checker<_Types["MiningEquipemntProps"], typeof MiningEquipemntImplementation>;

export namespace templates {
    export type MiningEquipemnt = _Types["MiningEquipemntProps"];
}


        



import CrushersImplementation from "@client/templates/Crushers"
export type CrushersCheck = Checker<_Types["CrushersProps"], typeof CrushersImplementation>;

export namespace templates {
    export type Crushers = _Types["CrushersProps"];
}


        



import MobileSeriesImplementation from "@client/templates/MobileSeries"
export type MobileSeriesCheck = Checker<_Types["MobileSeriesProps"], typeof MobileSeriesImplementation>;

export namespace templates {
    export type MobileSeries = _Types["MobileSeriesProps"];
}


        



import SemiMobileSeriesImplementation from "@client/templates/SemiMobileSeries"
export type SemiMobileSeriesCheck = Checker<_Types["SemiMobileSeriesProps"], typeof SemiMobileSeriesImplementation>;

export namespace templates {
    export type SemiMobileSeries = _Types["SemiMobileSeriesProps"];
}


        



import SparesImplementation from "@client/templates/Spares"
export type SparesCheck = Checker<_Types["SparesProps"], typeof SparesImplementation>;

export namespace templates {
    export type Spares = _Types["SparesProps"];
}


        



import CementMillLinersImplementation from "@client/templates/CementMillLiners"
export type CementMillLinersCheck = Checker<_Types["CementMillLinersProps"], typeof CementMillLinersImplementation>;

export namespace templates {
    export type CementMillLiners = _Types["CementMillLinersProps"];
}


        



import DipTubeImplementation from "@client/templates/DipTube"
export type DipTubeCheck = Checker<_Types["DipTubeProps"], typeof DipTubeImplementation>;

export namespace templates {
    export type DipTube = _Types["DipTubeProps"];
}


        

